module.exports = __webpack_public_path__ + "static/media/2DGACM12.c27e9893.jpg";